import { render, staticRenderFns } from "./RedeCredenciadaLista.vue?vue&type=template&id=064e567a&"
import script from "./RedeCredenciadaLista.vue?vue&type=script&lang=js&"
export * from "./RedeCredenciadaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports